import { EnvironmentalVariables } from "enum/EnvironmentalVariables";
import { reverseDirection } from "util/meteogramCharts/meteogramFormatTooltip/meteogramFormatTooltip";
import useConvertValueToUserUnit from "hooks/useConvertValueToUserUnit";

export interface SensorMarkerIcon {
  degrees?: number;
  value?: number;
  markerIcon?: string | undefined;
  defaultUnit?: string;
  environmentalVariable?: string;
  isSelected?: boolean;
  isSensorSelectionMode?: boolean;
}

export const SensorMarker = ({
  degrees,
  value,
  markerIcon,
  defaultUnit,
  environmentalVariable,
  isSelected = false,
  isSensorSelectionMode = false,
}: SensorMarkerIcon) => {
  const { unit } = useConvertValueToUserUnit({
    value,
    environmentalVariable,
    defaultUnit,
  });

  const isCurrent =
    environmentalVariable === EnvironmentalVariables.CURRENT_VEL;

  const isPrecip =
    environmentalVariable === EnvironmentalVariables.PRECIP ||
    environmentalVariable?.startsWith("precip_accum");

  // For precipitation, display raw value when conversion is unavailable
  const displayValue =
    unit != null ? unit : isPrecip && value != null ? value : null;

  const background = isSensorSelectionMode
    ? isSelected
      ? "#24954e"
      : "#4a6075"
    : "#286795";

  const border =
    isSensorSelectionMode || isSelected ? "0.1rem solid white" : "";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        padding: isSelected ? "0.1rem 0.4rem" : "0 0.3rem",
        width: "max-content",
        background,
        borderRadius: 6,
        border,
      }}
    >
      {!!markerIcon && (
        <img
          style={{
            transform: isCurrent
              ? `rotate(${reverseDirection(degrees ?? 0)}deg)`
              : `rotate(${degrees}deg)`,
            minWidth: isPrecip ? "0.6rem" : "0.5rem",
            minHeight: isPrecip ? "0.6rem" : "0.5rem",
          }}
          src={markerIcon}
          alt="marker icon"
        />
      )}

      {displayValue != null && (
        <h3
          style={{
            fontSize: "0.6rem",
            color: "#fff",
            fontWeight: "bold",
          }}
        >
          {displayValue.toFixed(1)}
        </h3>
      )}
    </div>
  );
};
